module.exports = "<fw-title-bar></fw-title-bar>\n\n<fw-breadcrum></fw-breadcrum>\n\n<fw-content></fw-content>\n\n<fw-status-bar></fw-status-bar>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/framework-body/framework-body.component.html
// module id = 1851
// module chunks = 1